export const user = (state) => state.user;
export const userName = (state) => state.user?.jwt.name;
export const userEmail = (state) => state.user?.jwt.email;
export const userUsername = (state) => state.user?.jwt.username;
export const loggedIn = (state) => !!state.user?.jwt?.account_id;
export const userCompanies = (state) => state.user?.companies;
export const companyId = (state) => state.user?.jwt.companyId;
export const admin = (state) => state.user?.jwt?.admin === true;
